import React from "react";
import SidebarButton from "../SidebarButton";

export const TemplateItem = ({link, title, imageNumber}) => {
    return (
        <SidebarButton href={link}>
            <div>
                <strong>{title}</strong>
                <img alt="welcome" src={`${process.env.PUBLIC_URL}/email-templates/template_${imageNumber}.webp`}/>
                <div style={{borderBottom: "1px solid #ccc", paddingTop: '30px', marginBottom: '20px'}} />
            </div>
        </SidebarButton>
    )
}